export type TrainingStatusAction = "terminer" | "annuler" | "en_cours" | "valider";

export type PendingStatusAction = "terminer" | "annuler";

export const trainingStatusActionEmoji: Record<TrainingStatusAction, string> = {
  valider: "✅",
  terminer: "🏁",
  en_cours: "▶️",
  annuler: "❌",
};

export const trainingStatusActionA11yFr: Record<TrainingStatusAction, string> = {
  valider: "Valider la qualification",
  terminer: "Terminer la formation",
  en_cours: "Remettre en cours",
  annuler: "Annuler la formation",
};

export function pendingStatusRowEmoji(action: PendingStatusAction): string {
  return action === "terminer"
    ? trainingStatusActionEmoji.terminer
    : trainingStatusActionEmoji.annuler;
}
